import { useState } from "react";
import { Menu, X } from "lucide-react";
import { LOGO_URL, NAV_LINKS } from "@/content";

export const Nav = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/80 backdrop-blur-xl">
      <div
        data-testid="promo-banner"
        className="border-b border-white/10 bg-white px-6 py-2 text-center"
      >
        <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.25em] text-black sm:text-xs">
          Black Friday — code{" "}
          <span data-testid="promo-code" className="underline underline-offset-4">
            BFDAH
          </span>{" "}
          · 25% off before Black Friday · 50% off on Black Friday
        </p>
      </div>
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
        <a href="#top" data-testid="nav-logo-link" className="flex items-center">
          <img
            src={LOGO_URL}
            alt="Desires After Hours flame logo"
            className="h-9 w-9 rounded-full object-cover ring-1 ring-white/20"
          />
        </a>

        <nav className="hidden items-center gap-6 lg:flex xl:gap-8">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={link.testid}
              className="text-xs font-medium uppercase tracking-[0.2em] text-zinc-400 transition-colors duration-300 hover:text-white"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-cta-button"
            className="whitespace-nowrap rounded-full bg-white px-5 py-2 text-xs font-semibold uppercase tracking-[0.15em] text-black transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-zinc-300"
          >
            Connect With Us
          </a>
        </nav>

        <button
          data-testid="nav-mobile-menu-button"
          onClick={() => setOpen(!open)}
          className="text-white lg:hidden"
          aria-label="Toggle navigation menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <nav
          data-testid="nav-mobile-menu"
          className="border-t border-white/10 bg-black/95 px-6 py-6 backdrop-blur-xl lg:hidden"
        >
          <div className="flex flex-col gap-5">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`nav-mobile-${link.label.toLowerCase()}-link`}
                onClick={() => setOpen(false)}
                className="text-sm font-medium uppercase tracking-[0.2em] text-zinc-300 transition-colors duration-300 hover:text-white"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              data-testid="nav-mobile-cta-button"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex w-fit rounded-full bg-white px-5 py-2 text-xs font-semibold uppercase tracking-[0.15em] text-black"
            >
              Connect With Us
            </a>
          </div>
        </nav>
      )}
    </header>
  );
};
